import FieldDefinitionRecord from 'customer-data-filters-ui/filterQueryFormat/fieldDefinitions/FieldDefinitionRecord';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import PropertyTypesType from 'customer-data-objects-ui-components/propTypes/PropertyTypesType';
export default PropTypes.oneOfType([ImmutablePropTypes.mapContains({
  getLabelString: PropTypes.func,
  inputType: PropertyTypesType,
  valueType: PropertyTypesType,
  InputComponent: PropTypes.func,
  ValueComponent: PropTypes.func
}).isRequired, PropTypes.instanceOf(FieldDefinitionRecord).isRequired]);